module.exports = __webpack_public_path__ + "static/media/Earn_Credits.500f2bff.png";